import "./Header.scss";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { PublicKey } from "@solana/web3.js";
import { useDetectOutsideClick } from "../../useDetectOutsideClick";
import { KeyIcon } from "../../assets/svg/KeyIcon";
import { MenuIcon } from "../../assets/svg/MenuIcon";
import { SearchIcon } from "../../assets/svg/SearchIcon";
import { WalletIcon } from "../../assets/svg/WalletIcon";
import { useWallet } from "@solana/wallet-adapter-react";

const Header = ({ isTransparent = false }) => {
  let navigate = useNavigate();
  const [isSearchKey, setIsSearchKey] = useState(false);
  const [formPublicKey, setFormPublicKey] = useState("");
  const [isValidKey, setIsValidKey] = useState(true);

  const [errorMsg, setErrorMsg] = useState("");
  const { publicKey } = useWallet();

  const handleRedirectToNFT = (keyvalue) => {
    let formPublicKey = "";

    setIsValidKey(false);
    if (keyvalue.length >= 32 && keyvalue.length <= 44) {
      formPublicKey = keyvalue;
      setIsValidKey(true);
    }

    if (formPublicKey) {
      try {
        const address: PublicKey = new PublicKey(formPublicKey);
        if (PublicKey.isOnCurve(address.toBuffer())) {
          setIsSearchKey(false);
          setIsValidKey(true);
          navigate(`/${formPublicKey}`);
        } else {
          setErrorMsg("Please Enter Valid Key");
          setIsValidKey(false);
        }
      } catch (error) {
        setErrorMsg("Please Enter Valid Key");
        setIsValidKey(false);
      }
    }
  };

  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsActive(!isActive);
  };

  useEffect(() => {
    if(!formPublicKey)
    {
      if(publicKey)
      {
        setFormPublicKey(publicKey.toString())
      }
    }
  }, [publicKey]);

  return (
    <header className={isTransparent ? "header-transparent" : ""}>
      <div className="container">
        {/* Mobile Header */}
        <div className="mobile-header">
          {isSearchKey ? (
            <>
              <span className="keyinput">
                <input
                  type="text"
                  className={isValidKey ? " " : "error"}
                  value={formPublicKey}
                  placeholder="Enter a Public Key"
                  onChange={(e) => {
                    setFormPublicKey(e.target.value);
                    handleRedirectToNFT(e.target.value);
                    setErrorMsg("");
                  }}
                />
                <span
                  className="search-icon"
                  onClick={() => {
                    handleRedirectToNFT(formPublicKey);
                  }}
                >
                  <SearchIcon />
                </span>
              </span>
              <span
                className="cancelBtn"
                onClick={() => {
                  setFormPublicKey("");
                  setIsSearchKey(!isSearchKey);
                  setIsValidKey(true);
                }}
              >
                Cancel
              </span>
            </>
          ) : (
            <>
              <div
                className="logo"
                onClick={() => {
                  navigate(`/`);
                }}
              >
                Bit
                <span>
                  <b>Fleqs</b>
                </span>
              </div>
              <div className="menubox">
                <span
                  className="key"
                  onClick={() => {
                    setIsSearchKey(!isSearchKey);
                  }}
                >
                  <KeyIcon />
                </span>

                <span
                  className="menu"
                  onClick={(e) => {
                    if (publicKey && isActive) {
                      setIsActive(true);
                    } else {
                      onClick(e);
                    }
                  }}
                >
                  <MenuIcon />
                  <div
                    ref={dropdownRef}
                    className={`menu-drawer ${isActive ? "active" : "inactive"}
                    `}
                  >
                    <WalletMultiButton className="walletbtn" />
                  </div>
                </span>
              </div>
            </>
          )}
        </div>

        {/* Desktop Header */}
        <div className="header">
          <div
            className="logo"
            onClick={() => {
              navigate(`/`);
            }}
          >
            Bit
            <span>
              <b>Fleqs</b>
            </span>
          </div>
          <div className="menubox">
            {isSearchKey ? (
              <>
                <span className="keyinput">
                  <input
                    type="text"
                    className={isValidKey ? " " : "error"}
                    value={formPublicKey}
                    placeholder="Enter a Public Key"
                    onChange={(e) => {
                      setFormPublicKey(e.target.value);
                      handleRedirectToNFT(e.target.value);
                      setErrorMsg("");
                    }}
                  />
                  <span
                    className="search-icon"
                    // onClick={() => {
                    //   handleRedirectToNFT(formPublicKey);
                    // }}
                  >
                    <KeyIcon />
                  </span>
                </span>
                <span
                  className="cancel-btn"
                  onClick={() => {
                    setFormPublicKey("");
                    setIsSearchKey(!isSearchKey);
                    setIsValidKey(true);
                  }}
                >
                  Cancel
                </span>
              </>
            ) : (
              <span
                className="key"
                onClick={() => {
                  setIsSearchKey(!isSearchKey);
                }}
              >
                <KeyIcon />
              </span>
            )}
            <div className="wallet-hover">
              <WalletMultiButton>
                {publicKey ? (
                  ""
                ) : (
                  <span className="walletmenu">
                    <WalletIcon />
                    <p>Connect to Wallet</p>
                  </span>
                )}
              </WalletMultiButton>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
